import { render, staticRenderFns } from "./team-members-module.vue?vue&type=template&id=331523c1&"
import script from "./team-members-module.vue?vue&type=script&lang=js&"
export * from "./team-members-module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports